import { Url } from '@wix/da-url';

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.textContent || '';
}

let tabTitle;
let tabFaviconUrl;

export function toggleWindowTabAsUnread(
  environmentType: string,
  username: string
) {
  if (username === '' || username === 'devart') {
    return;
  }

  // update favicon directly with JS to bypass any non-focused tab memory saving
  const faviconNode = document.querySelector('link[rel="shortcut icon"]');
  if (!faviconNode) {
    return;
  }

  if (!tabFaviconUrl) {
    tabFaviconUrl = faviconNode.getAttribute('href');
  }

  if (!tabTitle) {
    tabTitle = document && document.title;
  }

  function onVisibilityChange() {
    document.title = tabTitle;
    window.requestAnimationFrame(
      () =>
        tabFaviconUrl &&
        faviconNode &&
        faviconNode.setAttribute('href', tabFaviconUrl)
    );
  }

  // update tab title
  document.title = `${escapeHtml(username)} messaged you`;
  document.removeEventListener('visibilitychange', onVisibilityChange);
  document.addEventListener('visibilitychange', onVisibilityChange, {
    once: true,
  });

  // update tab favicon
  let faviconUrl;

  switch (environmentType) {
    // same icon for dev / rc
    case 'dev':
    case 'rc':
      faviconUrl = Url.staticCDNLink(
        'eclipse/icons/favicon-dot-staging_32x32.png'
      );
      break;
    default:
      faviconUrl = Url.staticCDNLink('eclipse/icons/favicon-dot_32x32.png');
      break;
  }

  faviconNode.setAttribute('href', faviconUrl);
}
